import FormEventSeating from './FormEventSeating';

export default FormEventSeating;
